export const RECRUITER = 'RECRUITER';

export const EMPLOYER = 'EMPLOYER';

export const ADMIN = 'MANAGER';

export const ACTIVE = 'active';

export const PENDING = 'PENDING';

export const REJECTED = 'rejected';

export const NONPUBLISHED = 'nonPublished';
